import { ComplexValue } from 'app/types-shared';
import { BowtieCase, BowtieCaseModel, DraftConnections } from '../types';
import { flattenAnchorRoots } from './map-anchor';

export const getConnectionsFromCase = (draft: BowtieCase, caseNo: number): ComplexValue<number>[] => {
  const connectionTypes = draft && draft.subTables && draft.subTables.TblConnectionTypes || [];

  const filteredByCaseNo = connectionTypes.filter(type => type && type.subTables && type.subTables.TblTransConnected &&
    type.subTables.TblTransConnected.some(conn => conn && conn.primaryKey && conn.primaryKey.v === caseNo));

  return filteredByCaseNo.map(type => ({
    value: type && type.primaryKey && type.primaryKey.v || undefined,
    description: type && type.primaryKey && type.primaryKey.d || undefined,
    icon: type && type.primaryKey && type.primaryKey.i || undefined
  }));
};

export const mapDraftConnections = (
  bowtie: BowtieCaseModel,
  draft: BowtieCase,
  casesRequiringUpdate: number[] = []
): DraftConnections[] => {

  const caseNumbers = [...new Set(flattenAnchorRoots((bowtie || {}).anchors))];

  return caseNumbers
    .map<DraftConnections>(caseNumber => ({
      caseNumber,
      connections: getConnectionsFromCase(draft, caseNumber),
      updating: casesRequiringUpdate.includes(caseNumber)
    }))
    .filter(draftConnection => draftConnection.updating ||
      (draftConnection.connections || []).length > 0);
};
